module.exports = __webpack_public_path__ + "static/media/skywallet_hdk_2.fd460269.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/components/GalleryHDK/images/skywallet_hdk_2.png
// module id = 1427
// module chunks = 0